import { useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

/**
 * BettingPL Component
 * 
 * Page for viewing betting P&L reports with date filters.
 */
function BettingPL() {
  const [fromDate, setFromDate] = useState('2025-12-27')
  const [toDate, setToDate] = useState('2026-01-03')

  // Static data matching the image structure
  const tableData = [
    // Add sample data here if needed
  ]

  return (

      <div className=" w-full mx-auto bg-[#0f1224] h-auto ">
      

        {/* Filter Section */}
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)", marginTop: "-10px" }}
          className="shadow-sm mt-2 px-1 py-2"
        >
          <div className="flex flex-wrap items-end gap-4 mb-4">
          

            <div style={{ width: "16%" }} className="flex flex-col">
              <label className="text-white text-[12px] font-bold mb-1">From</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="px-2 py-2 text-[12px] bg-white text-black rounded-sm border-none focus:outline-none"
              />
            </div>

            <div style={{ width: "16%" }} className="flex flex-col">
              <label className="text-white text-[12px] font-bold mb-1">To</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="px-2 py-2 text-[12px] bg-white text-black rounded-sm border-none focus:outline-none"
              />
            </div>

          

           
            <button
              className="px-6 py-2 bg-[#11374a] text-white font-medium text-[12px] rounded-sm transition-colors flex items-center gap-2"
            >
              <FontAwesomeIcon icon={faSearch} />
              Search
            </button>
          </div>

          {/* Table Controls */}
          
        </div>

        <div className="w-full h-px px-1 bg-white mb-2"></div>

        {/* Table Section */}
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
          className="shadow-sm px-4 py-2"
        >
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr>
                  <th className="text-left px-2 py-1 text-white font-bold text-[14px]">
                    Market
                  </th>
                  <th className="text-left px-2 py-1 text-white font-bold text-[14px]">
                    Start Time
                  </th>
                  <th className="text-left px-2 py-1 text-white font-bold text-[14px]">
                    Settled
                  </th>
                  <th style={{ width: "10%" }} className="text-right px-2 py-1 text-white font-bold text-[14px]">
                    Net Win
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="px-2 py-8 text-center text-gray-400">
                      {/* There are no records to show */}
                    </td>
                  </tr>
                ) : (
                  tableData.map((row, index) => (
                    <tr
                      key={row.id}
                      className={`transition-colors ${
                        index % 2 === 0 ? "bg-[rgba(245,245,245,0.1)]" : ""
                      }`}
                    >
                      <td className="py-1 px-2 text-white text-[13px]">
                        {row.market}
                      </td>
                      <td className="py-1 px-2 text-white text-[13px]">
                        {row.startTime}
                      </td>
                      <td className="py-1 px-2 text-white text-[13px]">
                        {row.settled}
                      </td>
                      <td className="py-1 px-2 text-white text-[13px]">
                        {row.netWin}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>

  )
}

export default BettingPL
